export default __webpack_public_path__ + "static/media/invoice-logo.f2ffc8a7.png";